import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotsController } from '../../controllers/slots-ng-controller';
import componentStyles from './sic-annuity-rate-table-wrapper.css.lit';
import './sic-rate-table';

/**
 * Annuity Product Rate Table Wrapper component
 * @slot table-heading
 * @slot rate-table (separate component)
 * @slot page-date
 * @slot disclaimer
 */

@customElement('sic-annuity-rate-table')
export class SicAnnuityRateTable extends OutlineElement {
  slots = new SlotsController(this);
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="wrapper">
        <div class="header">
          ${this.slots.conditionalSlot('table-heading')}
          ${this.slots.conditionalSlot('page-date')}
        </div>
        ${this.slots.conditionalSlot('rate-table', false)}
        ${this.slots.conditionalSlot('disclaimer', false)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-annuity-rate-table': SicAnnuityRateTable;
  }
}
